import { render, staticRenderFns } from "./Portfolio_balance.vue?vue&type=template&id=7927c16c&scoped=true&"
import script from "./Portfolio_balance.vue?vue&type=script&lang=js&"
export * from "./Portfolio_balance.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio_balance.vue?vue&type=style&index=0&id=7927c16c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7927c16c",
  null
  
)

export default component.exports